// MultiStepForm.jsx
import React, { useEffect } from "react";
import { useForm, useStep } from "react-hooks-helper";
import FormBasics from "./FormBasics";
import FormIncome from "./FormIncome";
import FormExpense from "./FormExpense";
import Review from "./Review";
import Success from "./Success";

const steps = [
  { id: "Basic Information" },
  { id: "Expenditure" },
  { id: "Income" },
  { id: "Review" },
  { id: "Success" },
];

const defaultData = {
  firstName: "",
  lastName: "",
  legalStatus: "",
  dob: "",
  schoolEmail: "",
  personalEmail: "",
  phone: "",
  address: "",
  city: "",
  zipcode: "",
  state: "",
  school: "",
  progress: "",
  program: "",
  studentId: "",
  startYear: "",
  grade: "",
  militaryAffiliation: "",
  // Expenditure
  rent: "",
  utilities: "",
  tuition: "",
  // Income
  salary: "",
  stipend: "",
  federal: "",
  incomeFromstate: "",
  university: "",
  other: "",
  zelle: "",
  bankRouting: "",
  bankAccount: "",
  // Acknowledgement
  acknowledge: "",
};

const MultiStepForm = ({ images }) => {
  const [inputData, setForm] = useForm(defaultData);
  const { step, navigation } = useStep({ initialStep: 0, steps });
  const { id } = step;

  // On first mount (e.g., full page refresh), disable browser scroll restoration
  // and force the page to the top after paint.
  useEffect(() => {
    const { history } = window;
    let prevScrollRestoration;
    if ("scrollRestoration" in history) {
      prevScrollRestoration = history.scrollRestoration;
      history.scrollRestoration = "manual";
    }
    const t = setTimeout(() => {
      window.scrollTo({ top: 0, left: 0, behavior: "auto" });
    }, 0);
    return () => {
      clearTimeout(t);
      if ("scrollRestoration" in history) {
        history.scrollRestoration = prevScrollRestoration || "auto";
      }
    };
  }, []);

  // Whenever the step changes, scroll to top (smooth).
  useEffect(() => {
    const t = setTimeout(() => {
      window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    }, 0);
    return () => clearTimeout(t);
  }, [id]);

  const props = { inputData, setForm, navigation };

  switch (id) {
    case "Basic Information":
      return <FormBasics {...props} />;
    case "Expenditure":
      return <FormExpense {...props} />;
    case "Income":
      return <FormIncome {...props} />;
    case "Review":
      return <Review {...props} />;
    case "Success":
      return <Success {...props} />;
    default:
      return null;
  }
};

export default MultiStepForm;
